// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__nMVQF","title":"card_title__26kWs","inActive":"card_inActive__2svVi"};